import utils from '.'
import pubsub from 'pubsub-js'

const NotifyClient = function(opts) {
    utils.WildEmitter.call(this);
};

const pt = NotifyClient.prototype;

utils.WildEmitter.mixin(NotifyClient);
//订阅
pt.subscript = function(key, callback) {
    this.emit('subscript', {
        key: key,
        callback: callback
    });
    pubsub.subscribe('key',(name,params) => {
        callback(params)
    })
};

//反订阅
pt.unsubscript = function(key, callback) {
    this.emit('unsubscript', {
        key: key,
        callback: callback
    });
    PubSub.unsubscribe(key);
};

//广播消息
// key - 消息 Key
// msg - 消息内容, JSON 格式：
//       {
//           key: String,
//           data: String
//       }
pt.broadcase = function(msg) {
    if (!msg) {
        throw new Error('"msg" can not be empty');
    }
    if (!msg.key) {
        throw new Error('"msg.key" can not be empty');
    }
    this.emit('broadcase', msg);
   
};

export default NotifyClient;
